export default "__VITE_ASSET__D$IBUll0__"